import { z } from "zod";

const PASSWORD_MIN_LENGTH = 8;

/**
 * Password field with minimum length and special character requirements
 */
export const passwordField = z
  .string()
  .min(PASSWORD_MIN_LENGTH, {
    message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters long`,
  })
  .max(128, "Password must be 128 characters or less")
  .regex(/[!@#$%^&*(),.?":{}|<>]/, {
    message: "Password must contain at least one special character",
  });

/**
 * Password confirmation field (used with withPasswordConfirmation refinement)
 */
export const confirmPasswordField = z
  .string()
  .min(1, "Please confirm your password")
  .max(128, "Password must be 128 characters or less");

/**
 * Current password field for password change forms
 */
export const currentPasswordField = z
  .string()
  .min(1, "Current password is required")
  .max(128, "Password must be 128 characters or less");

/**
 * Simple password field for login (no special character requirement for validation,
 * since we're validating against stored password)
 */
export const loginPasswordField = z
  .string()
  .min(PASSWORD_MIN_LENGTH, {
    message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters long`,
  })
  .max(128, "Password must be 128 characters or less")
  .regex(/[!@#$%^&*(),.?":{}|<>]/, {
    message: "Password must contain at least one special character",
  });

